<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Info', route: '/backoffice/info/' }, { label: 'Aggiungi Info', route: '/backoffice/info/add' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formInfo" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati info</h2>
            <span class="ac-meta">titolo e descrizione per ogni voce</span>
        </div>

        <div class="flex lg:flex-row flex-col gap-6">
            <div *ngFor="let contenuto of info_items; let i = index" class="flex flex-col gap-4 flex-1">
                <div class="fld">
                    <label>* Titolo</label>
                    <input type="text" pInputText class="w-full" placeholder="Titolo" [formControlName]="'titolo_' + i" />
                    <small class="text-red-600 block mt-2 font-medium" *ngIf="formInfo.get('titolo_' + i)?.hasError('required') && (formInfo.get('titolo_' + i)?.dirty || formInfo.get('titolo_' + i)?.touched)">Il titolo è obbligatorio.</small>
                </div>
                <div class="fld">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + i" />
                </div>
                <div class="flex justify-end" *ngIf="info_items.length !== 1">
                    <button class="acc-btn acc-btn-ghost" type="button" (click)="onRemoveItem(i)">Rimuovi dato</button>
                </div>
            </div>
        </div>

        <div class="acc-actions">
            <button class="acc-btn" type="button" (click)="onAddItem()">Aggiungi un dato</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/info">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formInfo.valid">Aggiungi info</button>
        </div>
    </form>
</section>
